export default "__VITE_ASSET__DdrTNfjQ__"